import { IMerchandiseDetails } from "repoV2/features/Listing/Listing.interfaces";
import { ISessionDetailsObjInApiResponse } from "./apis/SessionDetailsApi/SessionDetailsApi.interface";

export const getMetchandiseBasicDetails = (
    extensiveListingDetails: ISessionDetailsObjInApiResponse
) => {
    const {
        enable_shiprocket,
        shipping_details,
        allow_overflow,
        total_inventory,
        purchased_inventory,
    } = extensiveListingDetails;

    const merchandiseDetails: IMerchandiseDetails = {
        enable_shiprocket,
        shipping_details,
        allow_overflow,
        total_inventory,
        purchased_inventory,
    };

    return merchandiseDetails;
};
